// eslint-disable-next-line import/no-extraneous-dependencies
import V3ScrollLock from 'v3-scroll-lock';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(V3ScrollLock, { allowTouchMove: () => false });
});
